
import { createFileRoute } from '@tanstack/react-router'
import { updateEntity } from '@/queries/updateEntityMutation';
import { DocumentEditor } from '@/components/document-editor/document-editor';
import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useRef } from 'react';

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/design/',
)({
  component: RouteComponent,
})

function RouteComponent() {

  const { entity_type_id, entity_id } = Route.useParams();
  const { data: result, isLoading } = useQuery(getEntityQueryOptions(entity_type_id, entity_id));
  const updateMutation = updateEntity();
  const debounceRef = useRef<number | undefined>(undefined);

  const debouncedOnChange = useCallback((blocks: any) => {
    // Clear the previous timeout
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // Set a new timeout
    debounceRef.current = setTimeout(() => {
      updateMutation.mutate({
        entityType: entity_type_id,
        entityId: entity_id,
        updates: {
          template: blocks
        }
      });

    }, 500); // 500ms debounce delay
  }, [entity_type_id, entity_id, updateMutation]);


  if (isLoading) {
    return <></>;
  }

  let blocks = [];

  if (result?.entity?.template) {
    blocks = result.entity.template;
  }

  return <DocumentEditor root_collection={result?.entity?.targetCollection ?? ''} blocks={blocks} onChange={debouncedOnChange} />
}
